export default __webpack_public_path__ + "static/meble-5eb77c501187a0536a33f13af2743475.jpg";